/** The filter dimensions written as repeated keys. */
const MULTI_KEYS = ['locations', 'languages', 'tags', 'experiences'] as const;

export type FilterUpdates = Partial<
  Record<(typeof MULTI_KEYS)[number], string[]>
> & { startDate?: string };

/**
 * The next search string for a filter change.
 *
 * Multi-selects are written as REPEATED keys (`?locations=a&locations=b`),
 * matching what the loader reads with `getAll`. Emptying a dimension removes
 * its key rather than leaving an empty value behind, so a cleared filter and
 * an absent one produce the same URL.
 *
 * Params this page does not own are preserved: the booking dialog keeps its
 * own state (`experienceId`, `eventId`, `t`, and the picker's
 * `language`/`locationId`) in the same URL, as does campaign tracking.
 */
export function buildFilterSearch(
  current: URLSearchParams,
  updates: FilterUpdates
): URLSearchParams {
  const next = new URLSearchParams(current);

  for (const key of MULTI_KEYS) {
    const values = updates[key];
    if (!values) continue;
    next.delete(key);
    for (const value of values) next.append(key, value);
  }

  // `startDate`, not `from`: `from` belongs to the booking dialog, which
  // shares this URL.
  if (updates.startDate !== undefined) {
    next.set('startDate', updates.startDate);
  }

  return next;
}
